import request from "@utils/request";

export function getDataLowLiquidityArbitrage(query) {
    return request({
        url: 'alert/data/low-liquidity-arbitrage',
        method: 'get',
        params: query
    })
}
